import type { Move } from '../../../schemas/move';
import { monacoArchetypeMoves } from './archetypes';
import { monacoInitialMoves, monacoStartingAutoMoves, monacoStartingChoiceMoves } from './initial';
import { monacoAdvanced2to5Moves } from './advanced-2-5';
import { monacoAdvanced6to10Moves } from './advanced-6-10';

export {
  monacoArchetypeMoves,
  monacoInitialMoves,
  monacoStartingAutoMoves,
  monacoStartingChoiceMoves,
  monacoAdvanced2to5Moves,
  monacoAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Monaco (manuale V1, sezione "Il
 * Monaco", rr. 4395-4779).
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 5 mosse iniziali automatiche + 3 mosse iniziali di scelta (`starting`,
 *    `pickCount: 1` sul gruppo di scelta — *Regola della Battaglia* /
 *    *Regola del Lavoro* / *Regola della Pietà*)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 43 mosse.
 *
 * **Pattern stress-testati per la prima volta in questa classe**:
 *  - **`MoveSchema.replaces` 2 casi consecutivi**: *Sii Come l'Acqua*
 *    sostituisce *Pace Interiore*; *Dono di Compassione* sostituisce *Atto
 *    Compassionevole*. Secondo uso strutturale del pattern dopo il Mago
 *    (FI-21).
 *  - **Mossa-config *Sentieri del Monaco*** con 7 opzioni di restrizione
 *    strutturate (`MoveSchema.choices`, choiceCount 1) + nome dell'ordine in
 *    description (FI-18).
 *  - **`prerequisites.anyOf` cross-class** verso Mago: *Mastro Artigiano*
 *    richiede *Regola del Lavoro* OR `mago.laboratorio`.
 *  - **Catene L2-5 → L6-10**: 4 catene di prerequisiti +
 *    2 catene via `replaces` (*Pace Interiore* → *Sii Come l'Acqua*; *Atto
 *    Compassionevole* → *Dono di Compassione*).
 */
export const monacoMoves: readonly Move[] = [
  ...monacoArchetypeMoves,
  ...monacoInitialMoves,
  ...monacoAdvanced2to5Moves,
  ...monacoAdvanced6to10Moves,
];
